
import { getFormBuilderAccessToken, type IGetFormBuilderAccessTokenInput } from "@services/api/authentication/form-builder-access-token/getFormBuilderAccessToken";
import { useEffect, useState } from "react";

export const useGetFormBuilderAccessToken = (forms: IGetFormBuilderAccessTokenInput["forms"]) => {

    const [formBuilderAccessToken, setFormBuilderAccessToken] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    
    const fetchFormBuilderAccessToken = async (forms: IGetFormBuilderAccessTokenInput["forms"]) => {
        try {
            setLoading(true);
            const response = await getFormBuilderAccessToken({
                forms
            });
            setLoading(false);
            setFormBuilderAccessToken(response);
        } catch (error) {
            setLoading(false);
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        fetchFormBuilderAccessToken(forms)
    }, []);

    return {
        formBuilderAccessToken,
        loading
    }
}